/**
 * Single chokepoint for reporting errors. Today logs to the console; later this
 * is where Sentry / Datadog / similar gets wired in. Callers pass a stable
 * scope (e.g. "session.create") and any context that helps triage.
 */
export const reportError = (scope: string, error: unknown, context?: Record<string, unknown>): void => {
  // TODO(observability): wire up real tracker here (Sentry / Datadog / etc.)
  console.error(`[${scope}]`, error, context ?? {});
};
